<template>
  <div class="p-pegas">
      <div class="card-table" :class="mode ? 'card__tableday' : 'card__tablenight'">
          <div class="card-table-body ifon-add-title-block">
              <el-row :gutter="20">
                  <el-col :span="12">
                      <div class="caz-blocks-sarcho-title">
                          <div class="content-title d-flex align-center mr-2" :class="mode ? 'content__titleday' : 'content__titlenight'">
                              {{ $t("message.question_type_list") }}
                          </div>
                          <div class="block-sarche">
                              <div class="header__search">
                                  <crm-input
                                      :size="'small'"
                                      :className="'w100'"
                                      :class="mode ? 'input__day' : 'input__night'"
                                      v-model="filterForm.search"
                                      :icon="'el-icon-search'"
                                  ></crm-input>
                              </div>
                          </div>
                          <!-- <div class="block-sarche ml-2">
                            <select-branch  
                              :size="'small'"
                              :class="mode ? 'input__day' : 'input__night'"
                              :id="filterForm.branch_id"
                              v-model="filterForm.branch_id" >
                            </select-branch>
                          </div> -->
                      </div>
                  </el-col>

                  <el-col :span="12" class="flex-style text-right">
                      <crm-create-and-column-settings
                          :permission="$options.name"
                          :class="mode ? 'button__settingsday' : 'button__settingsnight'"
                          @c-create="drawerCreate = true"
                          :columns="columns"
                          @c-change="updateColumn"
                          :v_can_create="'QuestionTypeListController@store'"
                      >
                      </crm-create-and-column-settings>
                  </el-col>
              </el-row>
          </div>
          <!-- end ifon-add-title-block -->

          <div class="card-table-header table-crm-smart">
              <table
                  :class="mode ? 'table__myday' : 'table__mynight'"
                  class="table-my-code table-bordered"
                  v-loading="loadingData"
              >
                  <thead>
                      <tr>
                          <th class="w50p" v-if="columns.id.show">
                              {{ columns.id.title }}
                          </th>

                          <th v-if="columns.name.show">
                              {{ columns.name.title }}
                          </th>

                          <th v-if="columns.created_at.show">
                              {{ columns.created_at.title }}
                          </th>

                          <th v-if="columns.updated_at.show">
                              {{ columns.updated_at.title }}
                          </th>

                          <th v-if="columns.settings.show">
                              {{ columns.settings.title }}
                          </th>
                      </tr>

                      <tr class="filter_sorche">
                          <th v-if="columns.id.show">
                              <el-input
                                  clearable
                                  size="mini"
                                  v-model="filterForm.id"
                                  :class="mode ? 'filter__day' : 'filter__night'"
                                  :placeholder="columns.id.title"
                                  class="id_input"
                              ></el-input>
                          </th>

                          <th v-if="columns.name.show">
                              <crm-input
                                  :placeholder="columns.name.title"
                                  :class="mode ? 'filter__day' : 'filter__night'"
                                  v-model="filterForm.name"
                              ></crm-input>
                          </th>

                          <th v-if="columns.created_at.show">
                              <crm-date-picker
                                  :placeholder="columns.created_at.title"
                                  :class="mode ? 'filter__day' : 'filter__night'"
                                  v-model="filterForm.created_at"
                              ></crm-date-picker>
                          </th>

                          <th v-if="columns.updated_at.show">
                              <crm-date-picker
                                  :placeholder="columns.updated_at.title"
                                  :class="mode ? 'filter__day' : 'filter__night'"
                                  v-model="filterForm.updated_at"
                              ></crm-date-picker>
                          </th>

                          <th
                              class="settinW"
                              v-if="columns.settings.show"
                          ></th>
                      </tr>
                  </thead>

                  <transition-group name="flip-list" tag="tbody">
                      <tr
                          v-for="questionTypeList in list"
                          :key="questionTypeList.id"
                          class="cursor-pointer"
                      >
                          <td v-if="columns.id.show">{{ questionTypeList.id }}</td>
                          <td v-if="columns.name.show">
                              {{ questionTypeList.title }}
                          </td>

                          <td v-if="columns.created_at.show">
                              {{ questionTypeList.created_at }}
                          </td>

                          <td v-if="columns.updated_at.show">
                              {{ questionTypeList.updated_at }}
                          </td>

                          <td
                              v-if="columns.settings.show"
                              class="settings-td"
                          >
                              <crm-settings
                                  :name="$options.name"
                                  :model="questionTypeList"
                                  :actions="actions"
                                  @edit="edit"
                                  :permissionShow="'QuestionTypeListController@update'"
                                  :permissionDestroy="'QuestionTypeListController@destroy'"
                                  @delete="destroy"
                              ></crm-settings>
                          </td>
                      </tr>
                  </transition-group>
              </table>
              <div class="my___pagination">
                  <crm-pagination
                      @c-change="updatePagination"
                      :class="mode ? 'pagination__day' : 'pagination__night'"
                      :pagination="pagination"
                  ></crm-pagination>
              </div>
          </div>

          <div class="app-modal app-modal__full">
              <el-drawer
                  :with-header="false"
                  :visible.sync="drawerCreate"
                  size="70%"
                  ref="drawerCreate"
                  @opened="drawerOpened('drawerCreateChild')"
                  @closed="drawerClosed('drawerCreateChild')"
              >
                  <crm-create
                      ref="drawerCreateChild"
                      drawer="drawerCreate"
                  ></crm-create>
              </el-drawer>

              <el-drawer
                  :with-header="false"
                  :visible.sync="drawerUpdate"
                  size="70%"
                  ref="drawerUpdate"
                  @opened="drawerOpened('drawerUpdateChild')"
                  @closed="drawerClosed('drawerUpdateChild')"
              >
                  <crm-update
                      :selectedItem="selectedItem"
                      ref="drawerUpdateChild"
                      drawer="drawerUpdate"
                  ></crm-update>
              </el-drawer>
          </div>
      </div>
  </div>
</template>
<script>
import list from "@/utils/mixins/list";
import CrmCreate from "./components/crm-create";
import CrmUpdate from "./components/crm-update";
import { i18n } from "@/utils/i18n";
import { mapGetters, mapActions, mapState } from "vuex";
export default {
  name: "questionTypeListController",
  mixins: [list],
  components: {
      CrmCreate,
      CrmUpdate,
  },

  data() {
      return {
      };
  },
  computed: {
      ...mapGetters({
          list: "questionTypeList/list",
          columns: "questionTypeList/columns",
          pagination: "questionTypeList/pagination",
          statues: "questionTypeList/statues",
          filter: "questionTypeList/filter",
          sort: "questionTypeList/sort",
          mode: "MODE"
      }),
      actions: function () {
          return ["edit", "delete"];
      },
  },
  methods: {
      ...mapActions({
          updateList: "questionTypeList/index",
          setPagination: "questionTypeList/setPagination",
          updateSort: "questionTypeList/updateSort",
          updateFilter: "questionTypeList/updateFilter",
          updateColumn: "questionTypeList/updateColumn",
          updatePagination: "questionTypeList/updatePagination",
          show: "questionTypeList/show",
          empty: "questionTypeList/empty",
          delete: "questionTypeList/destroy",
          refreshData: "questionTypeList/refreshData",
      }),
  },
};
</script>

